var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"id":"top","text-xs-center":""}},[_c('h1',{staticClass:"display-1"},[_vm._v("About me...")])]),_c('AboutResume'),_c('AboutTimeline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }